import * as E from './elements';

const TicketButton = (props) => {
  const { children } = props;
  return <E.CustomButton {...props}>{children}</E.CustomButton>;
};

export default TicketButton;
